export const SET_LANG_KOR = 'SET_LANG_KOR';

export const SET_LANG_ENG = 'SET_LANG_ENG';

export const setLangKor = () => {
    return {
        type : SET_LANG_KOR,
    };
};

export const setLangEng = () => {
    return {
        type : SET_LANG_ENG,
    };
};
